"use strict";

var controller = new ScrollMagic.Controller();
var tl = new TimelineMax();

if($('.lp-page .about').length){
    $(".about .about-top").each(function(i) {
      var aboutTtlCover = $(this).find(".title .panel-cover");
      var aboutTtlContent = $(this).find(".title .panel-content");
      var aboutTtl = $(this).find(".title span");
      var tl = new TimelineMax();

      tl.to(aboutTtlCover, .4, {
        className: "+=active",
      });
      tl.to(aboutTtlContent, .4, {
        className: "+=panel-visible",
      });
      tl.to(aboutTtl, .2, {
        className: "+=active",
      });

      tl.to(aboutTtlCover, .4, {
        className: "+=slide-active",
      });
      new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: .75,
        reverse: false
      }).setTween(tl).addTo(controller)
    });
    $(".about .about-middle").each(function(i) {
      var aboutMidTtlCover = $(this).find(".title .panel-cover");
      var aboutMidTtlContent = $(this).find(".title .panel-content");
      var aboutMidTtl = $(this).find(".title span");
      var tl = new TimelineMax();
      tl.to(aboutMidTtlCover, .4, {
        className: "+=active",
      });
      tl.to(aboutMidTtlContent, .4, {
        className: "+=panel-visible",
      });
      tl.to(aboutMidTtl, .2, {
        className: "+=active",
      });

      tl.to(aboutMidTtlCover, .4, {
        className: "+=slide-active",
      });
      new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: .75,
        reverse: false
      }).setTween(tl).addTo(controller)
  });
}

$(window).on('load',function(){
    if($('.lp-page .kv').length){

      tl.set(".kv .panel-cover", {
          	autoKill:false,
      })
      .to(".kv .heart-list", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(1) .panel-cover", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(2) .panel-cover", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(3) .panel-cover", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(1) .panel-content", .15, {
        className: "+=panel-visible",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(2) .panel-content", .15, {
        className: "+=panel-visible",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(3) .panel-content", .15, {
        className: "+=panel-visible",
        ease: Power0.easeIn,
        delay: 0,

      })

      .to(".kv .kv-logo span:nth-of-type(1) .panel-cover", .15, {
        className: "+=slide-active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(2) .panel-cover", .15, {
        className: "+=slide-active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-logo span:nth-of-type(3) .panel-cover", .15, {
        className: "+=slide-active",
        ease: Power0.easeIn,
        delay: 0,

      })

      .to(['.kv .kv-cs .panel-cover', '.kv .icn-fhc .panel-cover','.kv .kv-umami .panel-cover'], .5, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(['.kv .kv-cs .panel-content', '.kv .icn-fhc .panel-content','.kv .kv-umami .panel-content'], .15, {
        className: "+=panel-visible",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(['.kv .kv-cs .panel-cover', '.kv .icn-fhc .panel-cover','.kv .kv-umami .panel-cover'], .25, {
        className: "+=slide-active",
        ease: Power0.easeIn,
        delay: 0,
      })

      .to(".kv .kv-copy .panel-cover", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-copy .panel-content", .15, {
        className: "+=panel-visible",
        ease: Power0.easeIn,
        delay: 0,

      })
      .to(".kv .kv-copy .panel-cover", .25, {
        className: "+=slide-active",
        ease: Power0.easeIn,
        delay: 0,

      })

      .to(".kv .product-list", .25, {
        className: "+=active",
        ease: Power0.easeIn,
        delay: 0,

      })
    }
    if($('.lp-page #about').length){
      $('#about').imagesLoaded(function() {
        var aboutHeight = $('#about').outerHeight(true);
        var about = new ScrollMagic.Scene({
              triggerElement: "#about",
              reverse: true,
              triggerHook: 1,
              duration: aboutHeight,
            })
            .addTo(controller)
            .setClassToggle("body", "is-about-active")
      })
    }
    if($('.lp-page #lineup-wrapper').length){
      $('#lineup-wrapper').imagesLoaded(function() {
          var lineupHeight = $('#lineup-wrapper').outerHeight(true);
          var lineup = new ScrollMagic.Scene({
                triggerElement: "#lineup-wrapper",
                reverse: true,
                triggerHook: 1,
                duration: lineupHeight,
              })
              .addTo(controller)
              .setClassToggle("body", "is-lineup-active")
      })
    }
    if($('.lp-page #howto').length){
      $('#howto').imagesLoaded(function() {
        var howtoHeight = $('#howto').outerHeight(true);
        var howto = new ScrollMagic.Scene({
              triggerElement: "#howto",
              reverse: true,
              triggerHook: 1,
              duration: howtoHeight,
            })
            .addTo(controller)
            .setClassToggle("body", "is-howto-active")
      })
}
if($('.lp-page #comments').length){
    $('#comments').imagesLoaded(function() {
      var commentsHeight = $('#comments').outerHeight(true);
      var comments = new ScrollMagic.Scene({
            triggerElement: "#comments",
            reverse: true,
            triggerHook: 1,
            duration: commentsHeight,
          })
          .addTo(controller)
          .setClassToggle("body", "is-comments-active")
    })
  }
if($('.comments-top').length){
    $(".comments-top .comments-list").each(function(i) {
        var commentLi = $(this).find("li img");

        var tl = new TimelineMax();
        tl.to(commentLi, .4, {
          className: "+=active",
        });

        new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: .75,
          reverse: false
        }).setTween(tl).addTo(controller)
      });
  }
if($('.lp-page #smile').length){
    var smile = new ScrollMagic.Scene({
          triggerElement: "#smile",
          reverse: false,
          triggerHook: .5,
    })
    .addTo(controller)
    .setClassToggle("#smile", "is-active")
  }
if($('.lp-page #stress').length){
        var stress = new ScrollMagic.Scene({
              triggerElement: "#stress",
              reverse: false,
              triggerHook: .5,
              //duration: stressHeight,
        })
        .addTo(controller)
        .setClassToggle("#stress", "is-active")
  }
if($('.lp-page #wakeup').length){
            var wakeup = new ScrollMagic.Scene({
                  triggerElement: "#wakeup",
                  reverse: false,
                  triggerHook: .5,
                  //duration: stressHeight,
            })
            .addTo(controller)
            .setClassToggle("#wakeup", "is-active")
  }
if($('.lp-page #deep').length){
                var deep = new ScrollMagic.Scene({
                      triggerElement: "#deep",
                      reverse: false,
                      triggerHook: .5,
                      //duration: stressHeight,
                    })
                    .addTo(controller)
                    .setClassToggle("#deep", "is-active")
  }
if($('.lp-page #energy').length){
                  var energy = new ScrollMagic.Scene({
                      triggerElement: "#energy",
                      reverse: false,
                      triggerHook: .5,
                        //duration: stressHeight,
                  })
                  .addTo(controller)
                  .setClassToggle("#energy", "is-active")
  }
if($('.lp-page #howto').length){
      var howtoCap = new ScrollMagic.Scene({
          triggerElement: "#howto",
          reverse: false,
          triggerHook: .5,
                        //duration: smileHeight,
          })
          .addTo(controller)
          .setClassToggle(".step-caption", "is-active")
  }
})

document.addEventListener('DOMContentLoaded', function () {

  var mql = window.matchMedia('screen and (max-width: 980px)');

  function checkBreakPoint(mql) {
    if (mql.matches) {
        if($('.accordion-button').length){
          $(function() {
            $('.accordion-button').prev().hide();
            $('.accordion-button').on('click',function () {
                if ($(this).prev().is(':hidden')) {
                    $(this).prev().slideDown();
                    $(this).text('閉じる').addClass('close');
                } else {
                    $(this).prev().slideUp();
                    $(this).text('もっと読む').removeClass('close');
                }
              });
            });
          }
        if($('.lp-page .howto-swiper-container').length){
        var howtoswiper = new Swiper('.howto-swiper-container', {
          slidesPerView: 1,
          spaceBetween: 50,
          slidesPerView: 1.5,
          centeredSlides : true,
          navigation: {
            nextEl: '.howto-button-next',
            prevEl: '.howto-button-prev',
          },
        });
      }

  			var controller = new ScrollMagic.Controller();
  			var tl = new TimelineMax();

        if($('.lp-page .lineup').length){
          $(".lineup").each(function(i) {
            var panelTtlCover = $(this).find(".title .panel-cover");
            var panelTtlContent = $(this).find(".title .panel-content");
            var panelCover = $(this).find(".catchcopy .panel-cover");
            var panelContent = $(this).find(".catchcopy .panel-content");
            var catchcopy = $(this).find(".catchcopy");
            var tl = new TimelineMax();
            tl.to(panelTtlCover, .35, {
              className: "+=active",
            });
            tl.to(panelTtlContent, .35, {
              className: "+=panel-visible",
            });
            tl.to(panelTtlCover, .35, {
              className: "+=slide-active",
            });

            tl.to(panelCover, .35, {
              className: "+=active",
            });

            tl.to(panelContent, .35, {
              className: "+=panel-visible",
            });


            new ScrollMagic.Scene({
              triggerElement: this,
              triggerHook: 1,
              reverse: false
            }).setTween(tl).addTo(controller)
          });
        }
        if($('.lp-page').length){


          var showFlag = false;
          var topBtn = $('#pagetop');
          topBtn.css('bottom', '-100px');
          var showFlag = false;
          $(window).on('scroll',function () {
              if ($(this).scrollTop() > 500) {
                  if (showFlag == false) {
                      showFlag = true;
                      topBtn.stop().animate({'bottom' : '50px'}, 200);
                  }
              } else {
                  if (showFlag) {
                      showFlag = false;
                      topBtn.stop().animate({'bottom' : '-100px'}, 200);
                  }
              }
          });
          topBtn.on('click',function () {
              $('body,html').animate({
                  scrollTop: 0
              }, 500);
              return false;
          });



          var storeBtn = $('#sp-online-store');
          $('#sp-online-store').show();
          storeBtn.css('bottom', '-100px');
          $(window).on('scroll',function () {
            if ($(this).scrollTop() > 500 && $(this).scrollTop() < 11500) {
              storeBtn.stop().animate({'bottom' : '15px'}, 200);
            } else {
              storeBtn.stop().animate({'bottom' : '-100px'}, 200);
            }
          });
    }


    } else {

        var controller = new ScrollMagic.Controller();
  			var tl = new TimelineMax();

        if($('.lp-page .lineup').length){
          $(".lineup").each(function(i) {
            var panelTtlCover = $(this).find(".title .panel-cover");
            var panelTtlContent = $(this).find(".title .panel-content");
            var panelCover = $(this).find(".catchcopy .panel-cover");
            var panelContent = $(this).find(".catchcopy .panel-content");
            var catchcopy = $(this).find(".catchcopy");
            var tl = new TimelineMax();
            tl.to(panelTtlCover, .35, {
              className: "+=active",
            });
            tl.to(panelTtlContent, .35, {
              className: "+=panel-visible",
            });
            tl.to(panelTtlCover, .35, {
              className: "+=slide-active",
            });

            tl.to(panelCover, .35, {
              className: "+=active",
            });

            tl.to(panelContent, .35, {
              className: "+=panel-visible",
            });


            new ScrollMagic.Scene({
              triggerElement: this,
              triggerHook: .45,
              reverse: false
            }).setTween(tl).addTo(controller)
          });
      }
        if($('.lp-page .main-contents').length){
    			   var main = new ScrollMagic.Scene({
    						triggerElement: ".main-contents",
    						reverse: true,
    						triggerHook: 0,
    					})
    					.addTo(controller)
    					.on("progress", function(event) {
    						$("body").toggleClass('is-main-active');
    			    });
        }

        $(function() {
          if($('.lp-page .main-navigation').length){

              var navLink = $('.main-navigation li a');
              var contentsArr = new Array();
              for (var i = 0; i < navLink.length; i++) {
                var targetContents = navLink.eq(i).attr('href');
                if (targetContents.charAt(0) == '#') {
                  var targetContentsTop = $(targetContents).offset().top - 550;
                  var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true);
                  contentsArr[i] = [targetContentsTop, targetContentsBottom]
                }
              };

              $(window).on('load scroll', function() {
                currentCheck();
              });

              function currentCheck() {
                var windowScrolltop = $(window).scrollTop();
                for (var i = 0; i < contentsArr.length; i++) {
                  if (contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
                    navLink.removeClass('current');
                    navLink.eq(i).addClass('current');
                    i == contentsArr.length;
                  }
                };
              }

              navLink.on('click', function() {
                $('html,body').stop().animate({
                  scrollTop: $($(this).attr('href')).offset().top
                }, 500);
                return false;
              })

              $('html,body').animate({
                scrollTop: 0
              }, '1');

            }
        })
        
      }
  }

  mql.addListener(checkBreakPoint);
  checkBreakPoint(mql);
});
